<template>
  <div class="scroll-wrapper">
    <div class="client-payments">
      <el-form :inline="true" class="toolbar" @submit.prevent>
        <el-form-item>
          <el-date-picker
            v-model="filters.dates"
            type="daterange"
            start-placeholder="Начало"
            end-placeholder="Конец"
            format="dd.MM.yyyy"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.method" placeholder="Метод" clearable>
            <el-option label="Наличные" value="cash" />
            <el-option label="Безнал" value="cashless" />
            <el-option label="Абонемент" value="abonement" />
          </el-select>
        </el-form-item>
        <el-form-item class="toolbar__submit">
          <el-button type="primary" class="toolbar__submit-btn" @click="loadPayments">Обновить</el-button>
        </el-form-item>
      </el-form>

      <div class="payments-table-shell">
        <el-table :data="payments" class="payments-table" :row-class-name="rowClassName">
          <el-table-column label="Дата" min-width="170" class-name="payments-col payments-col--date">
            <template #default="{ row }">
              <span>{{ formatPaymentDate(row.created_at) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="client_name" label="Клиент" min-width="190" class-name="payments-col payments-col--client">
            <template #default="{ row }">
              <span>{{ row.client_name || '—' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="method" label="Метод" min-width="130" class-name="payments-col payments-col--method">
            <template #default="{ row }">
              <span>{{ getPaymentMethodLabel(row.method) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="Сумма" min-width="120" class-name="payments-col payments-col--amount">
            <template #default="{ row }">
              <el-tooltip
                v-if="(row.is_canceled || row.type === 'refund') && row.cancel_reason"
                :content="row.cancel_reason"
                placement="top">
                <div>
                  <span
                    class="payment-amount"
                    :class="{ 'is-canceled': row.is_canceled || row.type === 'refund' }"
                    :style="{ color: row.direction === 'out' ? 'var(--ui-color-danger-el)' : 'var(--ui-color-success)' }"
                  >
                    {{ row.direction === 'out' ? '–' : '+' }}{{ row.amount }} ₽
                  </span>
                </div>
              </el-tooltip>
              <span
                v-else
                class="payment-amount"
                :class="{ 'is-canceled': row.is_canceled || row.type === 'refund' }"
                :style="{ color: row.direction === 'out' ? 'var(--ui-color-danger-el)' : 'var(--ui-color-success)' }"
              >
                {{ row.direction === 'out' ? '–' : '+' }}{{ row.amount }} ₽
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="comment" label="Комментарий" min-width="240" class-name="payments-col payments-col--comment">
            <template #default="{ row }">
              <span class="payment-comment-text">{{ row.comment || '—' }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="payments-mobile-list">
        <div class="payments-mobile-head">
          <span class="payments-mobile-head__cell payments-mobile-head__cell--date">Дата</span>
          <span class="payments-mobile-head__cell payments-mobile-head__cell--client">Клиент</span>
          <span class="payments-mobile-head__cell payments-mobile-head__cell--method">Метод</span>
          <span class="payments-mobile-head__cell payments-mobile-head__cell--amount">Сумма</span>
          <span class="payments-mobile-head__cell payments-mobile-head__cell--comment">Комментарий</span>
        </div>

        <article v-for="payment in payments" :key="`mobile-payment-${payment.id || payment.created_at}`" class="payments-mobile-row">
          <div class="payments-mobile-cell payments-mobile-cell--date">
            <span class="payments-mobile-date-main">{{ formatPaymentDateShort(payment.created_at) }}</span>
            <span class="payments-mobile-date-sub">{{ formatPaymentTime(payment.created_at) }}</span>
          </div>
          <div class="payments-mobile-cell payments-mobile-cell--client">
            <span class="payments-mobile-client-name">{{ payment.client_name || '—' }}</span>
          </div>
          <div class="payments-mobile-cell payments-mobile-cell--method">
            <span>{{ getPaymentMethodLabel(payment.method, true) }}</span>
          </div>
          <div class="payments-mobile-cell payments-mobile-cell--amount">
            <span
              class="payment-amount"
              :class="{ 'is-canceled': payment.is_canceled || payment.type === 'refund' }"
              :style="{ color: payment.direction === 'out' ? 'var(--ui-color-danger-el)' : 'var(--ui-color-success)' }"
            >
              {{ payment.direction === 'out' ? '–' : '+' }}{{ payment.amount }} ₽
            </span>
          </div>
          <div class="payments-mobile-cell payments-mobile-cell--comment">
            <span class="payments-mobile-comment-text">{{ payment.comment || '—' }}</span>
          </div>
        </article>
      </div>

      <el-pagination
        v-if="total > limit"
        class="payments-pagination"
        background
        layout="prev, pager, next, jumper"
        :page-size="limit"
        :current-page="page"
        :total="total"
        @current-change="changePage"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ClientPayments',
  data() {
    return {
      filters: {
        dates: [],
        method: null
      },
      limit: 50,
      page: 1,
    }
  },
  computed: {
    ...mapState('payments', ['payments', 'total'])
  },
  methods: {
    ...mapActions('payments', ['fetchPayments', 'refundPayment', 'cancelPayment']),
    formatPaymentDate(timestamp) {
      return new Date(timestamp * 1000).toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    formatPaymentDateShort(timestamp) {
      return new Date(timestamp * 1000).toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit'
      })
    },
    formatPaymentTime(timestamp) {
      return new Date(timestamp * 1000).toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    getPaymentMethodLabel(method, compact = false) {
      if (method === 'cash') return compact ? 'Нал' : 'Наличные'
      if (method === 'cashless') return compact ? 'Безнал' : 'Безналичный'
      if (method === 'abonement') return 'Абонемент'
      return '—'
    },
    changePage(page) {
      this.page = page
      this.loadPayments()
    },
    loadPayments() {
      const params = {
        page: this.page,
        limit: this.limit,
        filters: {
          method: this.filters.method,
          date_from: this.filters.dates?.[0] || null,
          date_to: this.filters.dates?.[1] || null
        }
      }
      this.fetchPayments(params);
    },
    rowClassName({ row }) {
      return row.is_canceled || row.type === 'refund' ? 'is-canceled' : '';
    }
  },
  watch: {
    'filters.method'() {
      this.page = 1
      this.loadPayments()
    },
    'filters.dates': {
      handler() {
        this.page = 1
        this.loadPayments()
      },
      deep: true
    }
  },
  mounted() {
    this.loadPayments()
  }
}
</script>

<style scoped>
.client-payments {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 20px 12px 24px;
  color: var(--cal-text-inverse);
  font-family: var(--ui-font-family-base);
}

.scroll-wrapper {
  height: 100%;
  overflow-y: auto;
}

.toolbar {
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(180px, 0.74fr) minmax(180px, 0.56fr);
  gap: 12px;
  align-items: end;
  padding: 0;
}

.toolbar :deep(.el-form-item) {
  margin-bottom: 0;
  margin-right: 0 !important;
  width: 100%;
}

.toolbar :deep(.el-form-item__content),
.toolbar :deep(.el-date-editor.el-input__wrapper),
.toolbar :deep(.el-select),
.toolbar :deep(.el-select__wrapper) {
  width: 100% !important;
}

.toolbar__submit {
  width: 100%;
  box-sizing: border-box;
  padding-right: 0;
}

.toolbar :deep(.el-button) {
  min-height: 42px;
  border-radius: 9px;
  font-family: var(--ui-font-family-base) !important;
  font-size: 18px !important;
  font-weight: 700 !important;
}

.toolbar__submit-btn {
  width: 100%;
  padding: 0 20px;
}

.payments-table-shell {
  margin-top: 18px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.payments-mobile-list {
  display: none;
  margin-top: 18px;
}

.payments-mobile-head,
.payments-mobile-row {
  display: grid;
  grid-template-columns: minmax(0, 0.92fr) minmax(0, 0.72fr) minmax(0, 0.74fr) minmax(0, 0.78fr) minmax(0, 1.22fr);
  gap: 6px;
  align-items: center;
}

.payments-mobile-head {
  padding: 0 10px 6px;
}

.payments-mobile-head__cell {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(174, 194, 230, 0.68);
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.payments-mobile-head__cell--date,
.payments-mobile-head__cell--client,
.payments-mobile-head__cell--comment {
  justify-content: flex-start;
  text-align: left;
}

.payments-mobile-row {
  min-height: 58px;
  padding: 0 10px;
  background: #0c224b !important;
  box-shadow: inset 0 0 0 1px rgba(74, 106, 173, 0.08) !important;
  border-radius: 12px !important;
}

.payments-mobile-row + .payments-mobile-row {
  margin-top: 10px;
}

.payments-mobile-cell {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d7e7ff !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 12px;
  text-align: center;
}

.payments-mobile-cell--date,
.payments-mobile-cell--client,
.payments-mobile-cell--comment {
  justify-content: flex-start;
  text-align: left;
}

.payments-mobile-cell--date {
  flex-direction: column;
  align-items: flex-start;
}

.payments-mobile-cell--client {
  overflow: hidden;
}

.payments-mobile-client-name {
  color: #22c0ff;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.payments-mobile-date-main,
.payments-mobile-date-sub {
  width: 100%;
  white-space: nowrap;
}

.payments-mobile-date-main {
  color: #22c0ff;
}

.payments-mobile-date-sub {
  color: rgba(174, 194, 230, 0.72);
  font-size: 11px;
}

.payments-mobile-cell--comment,
.payments-mobile-comment-text {
  overflow: hidden;
}

.payments-mobile-comment-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: normal;
  line-height: 1.15;
}

.payments-table :deep(.payments-col--date .cell),
.payments-table :deep(.payments-col--client .cell),
.payments-table :deep(.payments-col--comment .cell) {
  justify-content: flex-start !important;
}

.payments-table :deep(.payments-col--method .cell),
.payments-table :deep(.payments-col--amount .cell) {
  justify-content: center !important;
}

.payment-comment-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  white-space: normal;
  line-height: 1.2;
}

.client-payments :deep(.el-table) {
  --el-table-bg-color: transparent;
  --el-table-tr-bg-color: transparent;
  --el-table-row-hover-bg-color: transparent;
  --el-table-header-bg-color: transparent;
  --el-table-border-color: transparent;
  --el-table-text-color: var(--cal-text-regular);
  --el-table-header-text-color: var(--cal-text-inverse);
  background: transparent;
  min-width: 820px;
}

.client-payments :deep(.el-table::before),
.client-payments :deep(.el-table__inner-wrapper::before) {
  display: none;
}

.client-payments :deep(.el-table th.el-table__cell),
.client-payments :deep(.el-table td.el-table__cell) {
  background: transparent;
  border-bottom: 0;
  padding: 0 7px 14px;
}

.client-payments :deep(.el-table th.el-table__cell:first-child),
.client-payments :deep(.el-table td.el-table__cell:first-child) {
  padding-left: 0;
}

.client-payments :deep(.el-table th.el-table__cell:last-child),
.client-payments :deep(.el-table td.el-table__cell:last-child) {
  padding-right: 0;
}

.client-payments :deep(.el-table th.el-table__cell .cell) {
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(rgb(0 108 254 / 22%), rgb(0 108 254 / 22%)),
    linear-gradient(180deg, #15264e 0%, #030b1b 100%) !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  color: #ffffff !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 21px !important;
  font-weight: 700 !important;
  line-height: 1 !important;
}

.client-payments :deep(.el-table td.el-table__cell .cell) {
  min-height: 52px;
  display: flex;
  align-items: center;
  background:
    linear-gradient(180deg, rgba(20, 37, 76, 0.82) 0%, rgba(3, 11, 27, 0.98) 100%) !important;
  box-shadow: inset 0 0 0 1px rgba(24, 49, 97, 0.95) !important;
  border-radius: 8px !important;
  padding: 0 18px !important;
  color: #22c0ff !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 16px !important;
  line-height: 1 !important;
}

.client-payments :deep(.el-input__wrapper),
.client-payments :deep(.el-select__wrapper),
.client-payments :deep(.el-date-editor.el-input__wrapper) {
  background: #07142d !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  border: none !important;
  min-height: 42px !important;
}

.client-payments :deep(.el-input__inner),
.client-payments :deep(.el-select__placeholder),
.client-payments :deep(.el-select__selected-item),
.client-payments :deep(.el-range-input) {
  color: #22c0ff !important;
  -webkit-text-fill-color: #22c0ff !important;
  font-family: var(--ui-font-family-base) !important;
  font-size: 18px !important;
  font-weight: 400 !important;
}

.client-payments :deep(.el-button--primary) {
  background: var(--appointment-primary) !important;
  border-color: transparent !important;
  color: var(--appointment-primary-text) !important;
}

.payments-pagination {
  margin-top: 18px;
  display: flex;
  justify-content: flex-end;
}

.client-payments :deep(.el-pagination) {
  --el-pagination-bg-color: transparent;
  --el-pagination-button-bg-color: #0c224b;
  --el-pagination-button-color: #aec2e6;
  --el-pagination-text-color: #aec2e6;
}

.client-payments :deep(.el-pagination .btn-prev),
.client-payments :deep(.el-pagination .btn-next) {
  background: #0c224b !important;
  box-shadow: 0 0 0 1px #1b3f7a inset !important;
  border-radius: 8px !important;
  color: #aec2e6 !important;
}

.payment-amount {
  font-size: 16px;
  font-weight: 600;
}
.is-canceled {
  text-decoration: line-through;
  color: var(--ui-color-text-muted);
}

@media (max-width: 900px) {
  .toolbar {
    grid-template-columns: 1fr 1fr;
  }

  .toolbar__submit {
    grid-column: 1 / -1;
    padding-right: 0;
  }
}

@media (max-width: 640px) {
  .client-payments {
    padding: 14px 12px 20px;
  }

  .toolbar {
    grid-template-columns: 1fr;
  }

  .toolbar :deep(.el-form-item),
  .toolbar :deep(.el-form-item__content),
  .toolbar :deep(.el-date-editor.el-input__wrapper),
  .toolbar :deep(.el-select),
  .toolbar :deep(.el-select__wrapper),
  .toolbar :deep(.el-button) {
    width: 100% !important;
  }

  .payments-table-shell {
    display: block;
  }

  .payments-mobile-list {
    display: none !important;
  }

  .payments-pagination {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .client-payments {
    padding: 8px 10px 14px;
  }

  .client-payments :deep(.el-table) {
    min-width: 930px;
  }

  .client-payments :deep(.el-table th.el-table__cell),
  .client-payments :deep(.el-table td.el-table__cell) {
    padding: 0 5px 10px;
  }

  .client-payments :deep(.el-table th.el-table__cell:first-child),
  .client-payments :deep(.el-table td.el-table__cell:first-child) {
    padding-left: 0;
  }

  .client-payments :deep(.el-table th.el-table__cell:last-child),
  .client-payments :deep(.el-table td.el-table__cell:last-child) {
    padding-right: 0;
  }

  .client-payments :deep(.el-table th.el-table__cell .cell) {
    min-height: 42px;
    font-size: 14px !important;
    justify-content: flex-start !important;
    padding-left: 12px !important;
  }

  .client-payments :deep(.el-table td.el-table__cell .cell) {
    min-height: 44px;
    padding: 0 10px !important;
    font-size: 12px !important;
  }

  .payment-amount {
    font-size: 12px;
  }
}
</style>

